// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.normal[data-v-2423c8d3], .hover[data-v-2423c8d3] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.normal .panel-field[data-v-2423c8d3], .hover .panel-field[data-v-2423c8d3] {\n  flex-basis: 50%;\n}\n\n", ""]);
// Exports
module.exports = exports;
